<template>
  <li>
    <div :class="{'is-open':isOpen}" class="node-name cursor-pointer font-condensed" @click="toggle(node)">
      <div>{{ node.name }}</div>
    </div>
    <b-collapse v-model="isOpen" :class="{'is-open':isOpen}" tag="ul">
      <table v-if="node.type === 'Component'" class="node-details text-gray-600 font-condensed pb-2">
        <tr v-for="item of node.child" :key="node.id + item.name">
          <th class="component-header">{{ item.name }}</th>
          <td class="d-flex justify-content-between align-content-start flex-wrap">
            <div v-for="tick of item.child" :key="node.id + item.name + tick" class="font-base flex-grow-1 d-inline-flex mx-1">
              <b-icon icon="check" class="text-green mr-2" />{{ tick.name }}
            </div>
          </td>
        </tr>
      </table>
      <b-tree-item v-for="item in node.child" v-else :key="item.id" :node="item" />
    </b-collapse>
    <hr class="m-0">
  </li>
</template>

<script>
export default {
  name: 'BTreeItem',
  props: {
    node: {
      type: Object
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {

  },
  mounted() {
    this.isOpen = this.node.child.length <= 1 && this.node.type === 'Sub System'
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
